var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicarDocumentoCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.691,
    height: 34.33,
    viewBox: "0 0 40.691 34.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pictograma_-_Publicar_Documento_hover_",
    "data-name": "Pictograma - Publicar Documento (hover)",
    className: "cls-1",
    d: "M20.33,0,0,17.169H2.93l3.46-.01V34.33H17.131V23.6H23.56V34.33H34.27V17.159l3.471.01h2.95Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicarDocumentoCursor);
export default __webpack_public_path__ + "static/media/publicarDocumentoCursor.127d889d7b8cb238ea1df03041a2f453.svg";
export { ForwardRef as ReactComponent };